// Must stay before 'logrocket' (see the module)
import './logrocket-off-host';
import LogRocket from 'logrocket';

import { REPORTING_ENABLED } from './is-production-host';

const LOGROCKET_API_KEY = 'kpprsc/platform-ff-ubbt0';


export const logRocketMiddleware = LogRocket.reduxMiddleware({
  stateSanitizer(state) {
    if (state.lastAction.meta && state.lastAction.meta.ignoreLogrocket) {
      return {
        ...state,
        lastAction: undefined,
      };
    }
    return state;
  },
  actionSanitizer(action) {
    if (action.meta && action.meta.ignoreLogrocket) {
      return null;
    }
    return action;
  },
});


export async function setupLogRocket() {
  if ( ! REPORTING_ENABLED) {
    return null;
  }

  const response = await fetch('/version.json');
  const body = response.status === 200 || response.status === 201 ? await response.json() : {};
  LogRocket.init(LOGROCKET_API_KEY, {
    release: body.version,
    network: {
      isEnabled: true,
      requestSanitizer(request) {
        if (request.headers['Content-Type'] === 'application/json') {
          const body = (typeof request.body === 'string') ? request.body : JSON.stringify(request.body);
          const cleanedBody = body ? body.replace(/,?"[\w-]*(password|creditCard)[-\w:"\s]*,?/, '') : null;
          request.body = (typeof request.body === 'string') ? cleanedBody : JSON.parse(cleanedBody);
          return request;
        }
        else {
          if (request.body && (typeof request.body === 'string')) {
            return request.body.includes('password') ? null : request;
          }
        }
      },
    },
  });
}


export default LogRocket;
